var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessionlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "url(#paint0_linear_3378_15078)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "url(#paint1_linear_3378_15078)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint2_linear_3378_15078)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint3_linear_3378_15078)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4062 37.3899L35.9688 35.9524V34.0938H34.5312V36.5476L36.3899 38.4062L37.4062 37.3899Z",
    fill: "#FFD119"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 41.2812C32.4756 41.2812 30.2188 39.0244 30.2188 36.25C30.2188 33.4756 32.4756 31.2188 35.25 31.2188C38.0244 31.2188 40.2812 33.4756 40.2812 36.25C40.2812 39.0244 38.0244 41.2812 35.25 41.2812ZM35.25 32.6562C33.2684 32.6562 31.6562 34.2684 31.6562 36.25C31.6562 38.2316 33.2684 39.8438 35.25 39.8438C37.2316 39.8438 38.8438 38.2316 38.8438 36.25C38.8438 34.2684 37.2316 32.6562 35.25 32.6562ZM38.125 29.7812H39.5625V22.5938C39.5625 21.801 38.9178 21.1562 38.125 21.1562H35.9688V22.5938H38.125V29.7812Z",
    fill: "#FFD119"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4688 29.7812C25.2627 29.7812 25.9062 29.1377 25.9062 28.3438C25.9062 27.5498 25.2627 26.9062 24.4688 26.9062C23.6748 26.9062 23.0312 27.5498 23.0312 28.3438C23.0312 29.1377 23.6748 29.7812 24.4688 29.7812Z",
    fill: "#FFD119"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 29.7812C30.2939 29.7812 30.9375 29.1377 30.9375 28.3438C30.9375 27.5498 30.2939 26.9062 29.5 26.9062C28.7061 26.9062 28.0625 27.5498 28.0625 28.3438C28.0625 29.1377 28.7061 29.7812 29.5 29.7812Z",
    fill: "#FFD119"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5312 29.7812C35.3252 29.7812 35.9688 29.1377 35.9688 28.3438C35.9688 27.5498 35.3252 26.9062 34.5312 26.9062C33.7373 26.9062 33.0938 27.5498 33.0938 28.3438C33.0938 29.1377 33.7373 29.7812 34.5312 29.7812Z",
    fill: "#FFD119"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0312 35.5312H20.875C20.0822 35.5312 19.4375 34.8865 19.4375 34.0938V22.5938C19.4375 21.801 20.0822 21.1562 20.875 21.1562H23.0312V22.5938H20.875V34.0938H23.0312V35.5312Z",
    fill: "#FFD119"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3378_15078",
    x1: 4.93903,
    y1: 63.2927,
    x2: 62.7439,
    y2: -4.02439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3378_15078",
    x1: 59.8171,
    y1: -7.68292,
    x2: 4.93902,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3378_15078",
    x1: 3.20968,
    y1: 10.4839,
    x2: 51.8226,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3378_15078",
    x1: 60.6935,
    y1: 61.9355,
    x2: 9.59677,
    y2: 25.7419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#FFD119",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionlogo);
export default __webpack_public_path__ + "static/media/Sessionlogo.90a7ccc6397f70a9d537ffb82b061858.svg";
export { ForwardRef as ReactComponent };